module.exports = __webpack_public_path__ + "img/light-r.1c7ac3f5.png";